import logo from './../resources/images/technogradLogo-01.png'

const MainBanner = () => {
    return (
        <div className="tg23-banner-head flex flex-center">
            <div className="tg23-banner-img-wrapper">
                <img alt='Logo' src={logo} />
            </div>
            <h2>TechnoGrad 1.0</h2>
            <p>"A celebration of innovation and knowledge!"</p>
            <p className='textalign-end underline'>15th & 16th of September, 2023!</p>
        </div>
    );
}

export default MainBanner